import { render, staticRenderFns } from "./base-bottom.vue?vue&type=template&id=16498f30&scoped=true"
import script from "./base-bottom.vue?vue&type=script&lang=js"
export * from "./base-bottom.vue?vue&type=script&lang=js"
import style0 from "./base-bottom.vue?vue&type=style&index=0&id=16498f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16498f30",
  null
  
)

export default component.exports